<div class="modal-header  justify-content-between">
    <h4 class="modal-title header-13">
      {{configs.title}}
    </h4>
    <div>
     <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button>
    </div>
  </div>
  
  <div class="detailed-content">
    <div class="row">
        <div class="col-md-6">
            <label class="form-label"> Operation Name </label>
            <input type="text" class="form-control" [(ngModel)]="data.name" placeholder="Enter operation name" [disabled]="configs.isEdit">
        </div>
        <div class="col-md-6">
            <label class="form-label"> Request Type </label>
            <app-dropdown-with-sections
            [customStyle]="{ image: { width: '40px' } }"
            [config]="dropdownConfig"
            [fields]="requestTypes"
            [selectedValue]="requestValue"
            (onSelect)="onChange($event)"
          ></app-dropdown-with-sections>
        </div>
    </div>
    <div class="mt-3">
        <label class="form-label"> Endpoint </label>
        <div class="url-inp">
            <span class="single-line-scroll"> {{ url }} </span>
            <input class="flex-grow-1 form-control" type="text" [(ngModel)]="data.url" placeholder="Add endpoint">
        </div>
    </div>
  </div>

  <div class="modal-footer border-0">
    <div class="d-flex justify-content-end">
      <button
        class="btn-accello-secondary mx-2 open-btn"
        (click)="activeModal.dismiss('Cross click')"
      >
        Cancel
      </button>
      <button
        class="btn-accello-primary-light open-btn"
        (click)="save()"
      >
        {{configs.saveBtnText}}
      </button>
    </div>
  </div>
  